import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ComingSoon } from "@/components/ComingSoon";
import { LoadingScreen } from "@/components/LoadingScreen";

/**
 * Regional lock — THE CIRCLE is exclusive to Kolkata.
 * Tries browser GPS first; the backend also runs an IP-geolocation fallback
 * in the same request. Backend env GEO_BYPASS=true skips the lock (dev/testing).
 */
export const GeoGate = ({ children }) => {
  const [status, setStatus] = useState(() =>
    sessionStorage.getItem("circle_geo_ok") === "1" ? "allowed" : "checking"
  );

  useEffect(() => {
    if (status !== "checking") return;
    let done = false;

    const verify = async (coords) => {
      if (done) return;
      done = true;
      try {
        const params = coords ? { lat: coords.latitude, lon: coords.longitude } : {};
        const { data } = await api.get("/geo/check", { params });
        if (data.allowed) {
          sessionStorage.setItem("circle_geo_ok", "1");
          setStatus("allowed");
        } else {
          setStatus("blocked");
        }
      } catch {
        setStatus("blocked");
      }
    };

    let fallbackTimer;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => { clearTimeout(fallbackTimer); verify(pos.coords); },
        () => { clearTimeout(fallbackTimer); verify(null); },
        { timeout: 6000, maximumAge: 600000 }
      );
      // Safety net: if the permission prompt hangs, fall back to IP check
      fallbackTimer = setTimeout(() => verify(null), 8000);
    } else {
      verify(null);
    }
    return () => clearTimeout(fallbackTimer);
  }, [status]);

  if (status === "checking") return <LoadingScreen />;
  if (status === "blocked") return <ComingSoon />;
  return children;
};
